import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
	selector: 'app-nav-tab',
	templateUrl: './nav-tab.component.html',
	styleUrls: ['./nav-tab.component.css']
})
export class NavTabComponent implements OnInit, AfterViewInit {
	public mainNav;
	public $magicLine;
	public $el;
	public tempWidget;
	constructor() {}
	@Input() widgets: string;

	ngOnInit(): void {
		this.tempWidget = JSON.parse(decodeURI(this.widgets))
			.map((el) => el.split(' ').join(''))
			.map((el) => el.replace('&', ''));
		this.widgets = JSON.parse(decodeURI(this.widgets));
	}

	ngAfterViewInit() {
		setTimeout(() => {
			let firstWidget: any = this.widgets[0].toLocaleLowerCase();
			$('#' + firstWidget + '-tab').addClass('active');
			$(".tab-content [unqiue-id='" + firstWidget + "']").show();
			this.mainNav = $('#navcontainer');
			this.mainNav.append("<li id='magic-line'></li>");
			this.$magicLine = $('#magic-line');
			this.$magicLine
				.css('left', $('.nav-link.active').position().left)
				.data('origLeft', this.$magicLine.position().left)
				.data('origWidth', this.$magicLine.width());
		});
	}

	openTab($event) {
		$event.preventDefault();
		$event.currentTarget.id = $event.currentTarget.id.replace('&', '');
		$('.tab-pane').hide();
		$('.nav a').removeClass('active');

		$('#' + $event.currentTarget.id).addClass('active');
		this.$el = $('.nav-link.active');
		this.$magicLine.css('left', this.$el.position().left);
		$(".tab-content [unqiue-id='" + $event.currentTarget.id.replace('-tab', '') + "']").show();
		window.dispatchEvent(new Event('resize'));
	}
}
